import React, { useState, useEffect } from "react";
import Sidebar, { SidebarContent } from "@/components/Sidebar";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import OfflineBanner from "@/components/OfflineBanner";
import EnableNotificationsBanner from "@/components/EnableNotificationsBanner";
import GlobalSearch from "@/components/GlobalSearch";
import { Menu, Search } from "lucide-react";

const LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_archi-interior-hub/artifacts/jmvnezz2_image.png";

export default function Layout({ children }) {
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        setSearchOpen(true);
      }
    };
    const onOpen = () => setSearchOpen(true);
    window.addEventListener("keydown", onKey);
    window.addEventListener("twp:open-search", onOpen);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("twp:open-search", onOpen);
    };
  }, []);

  return (
    <div className="flex min-h-screen bg-[#FAFAFA]">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <OfflineBanner />
        <EnableNotificationsBanner />
        {/* Mobile top bar */}
        <header className="lg:hidden sticky top-0 z-40 flex items-center gap-3 h-14 px-4 bg-zinc-50 border-b border-zinc-200">
          <button
            onClick={() => setOpen(true)}
            data-testid="mobile-menu-button"
            aria-label="Open menu"
            className="h-10 w-10 flex items-center justify-center rounded-sm text-zinc-700 hover:bg-zinc-200 active:bg-zinc-300 transition-colors"
          >
            <Menu className="h-6 w-6" />
          </button>
          <div className="flex items-center gap-2">
            <img src={LOGO} alt="TWP co" className="h-7 w-7 rounded-sm object-cover" />
            <span className="font-heading font-extrabold tracking-tight">TWP co</span>
          </div>
          <button
            onClick={() => setSearchOpen(true)}
            data-testid="mobile-search-button"
            aria-label="Search"
            className="ml-auto h-10 w-10 flex items-center justify-center rounded-sm text-zinc-700 hover:bg-zinc-200 active:bg-zinc-300 transition-colors"
          >
            <Search className="h-5 w-5" />
          </button>
        </header>
        <main className="flex-1 min-w-0">{children}</main>
      </div>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="p-0 w-72 max-w-[82vw]" data-testid="mobile-sidebar">
          <SheetHeader className="sr-only">
            <SheetTitle>Navigation</SheetTitle>
          </SheetHeader>
          <SidebarContent onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>

      {/* Single app-wide search dialog (⌘K / Ctrl+K, sidebar & mobile triggers) */}
      <GlobalSearch open={searchOpen} onOpenChange={setSearchOpen} hideTrigger />
    </div>
  );
}
